import {
  Bold,
  BulletList,
  ItalicLight,
  Link,
  NumberedList,
  Quote,
  Redo,
  StrikethroughLight,
  TextAlignLeft,
  TextStyles,
  UnderlineLight,
  Undo,
} from '@wix/wix-ui-icons-common';
import React from 'react';

import { classes } from './Icons.st.css';

export const IconsMobile = () => (
  <div className={classes.footerMobile}>
    <Undo className={classes.iconMobile} />
    <Redo className={classes.iconMobile} />
    <Bold className={classes.iconMobile} />
    <UnderlineLight className={classes.iconMobile} />
    <ItalicLight className={classes.iconMobile} />
    <StrikethroughLight className={classes.iconMobile} />
    <TextStyles className={classes.iconMobile} />
    <TextAlignLeft className={classes.iconMobile} />
    <NumberedList className={classes.iconMobile} />
    <BulletList className={classes.iconMobile} />
    <Link className={classes.iconMobile} />
    <Quote className={classes.iconMobile} />
  </div>
);
